module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir11-65261df29d39d9b728a00038d934d16b.jpg";